const set = require('regenerate')(0x303, 0x30D, 0x310, 0x32D, 0x331);
set.addRange(0x300, 0x301).addRange(0x11BC0, 0x11BE1).addRange(0x11BF0, 0x11BF9);
exports.characters = set;
